/* eslint-disable react/no-children-prop */
import React, {useContext, useEffect} from 'react';
import ReactMarkdown from 'react-markdown';
import '../styles.scss';
import {Seo} from '../../components/common';
import {ThemeContext} from '../../providers/ThemeProvider';
import styled from 'styled-components';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import PDFReader from './partials/PDFReader';

const MainContentContainer = styled.div`
  flex: 1; // push footer to the bottom
  background: ${({ theme }) => (theme === 'light' ? '#fff' : 'transparent')};
`;

const BookContainer = styled.div`
  background: ${({ theme }) => (theme === 'light' ? '#fff' : 'transparent')};
  color: ${({ theme }) => (theme === 'light' ? 'rgba(0,0,0,.84)' : 'rgb(230, 230, 230)')};
  max-width: 1200px;
  padding: 0 4% 6em 4%;
  margin: 0 auto;

  h2 {
    border-bottom: ${({ theme }) =>
      theme === 'light' ? '1px solid rgba(0,0,0,0.1)' : '1px solid rgba(255,255,255,0.5)'};
  }

  h2.section-title {
    padding-left: 0.5rem;
    border-left: 5px solid rgb(236, 133, 19);
    padding-top: 0;
    border-bottom: 1px solid rgb(236, 133, 19);
  }

  @media only screen and (min-width: 501px) {
    padding: 0 6% 6em 6%;
    .inline {
      display: inline;
    }
  }

  @media only screen and (max-width: 500px) {
    margin: 0 !important;
    // Make the book cover smaller
    .book-pic-container {
      padding: 0 18%;
    }

    p {
      padding-left: 10px;
      padding-right: 10px;
    }

    .book-event-info-divider {
      display: none;
    }
  }

  @media only screen and (min-width: 501px) and (max-width: 850px) {
    .book-pic-container {
      width: 35%;
      margin: 0.5em 1em 0 0 !important;
      float: left;

      .gap {
        padding-right: 1em;
      }
    }

    .book-introduction {
      display: inline;
    }
  }

  @media only screen and (min-width: 851px) {
    .grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: auto;
      grid-column-gap: 1.5em;
    }

    h2.book-title {
      grid-column-start: 1;
      grid-column-end: 5;
      margin-top: 0.35em;
      margin-bottom: 0.35em;
    }

    .book-pic-container {
      max-height: 500px;
      position: sticky;
      top: 1em;
      grid-column-start: 1;
      grid-column-end: 2;

      .gap {
        padding-right: 1em;
      }

      .book-link {
        width: 100%;
        box-sizing: border-box;
        margin-right: 2em;
      }
    }

    .book-introduction {
      grid-column-start: 2;
      grid-column-end: 5;
    }

    .book-review {
      grid-column-start: 2;
      grid-column-end: 5;
    }
  }

  .book-pic-container {
    margin: 1.5em 0 0 0;
    text-align: center;
    min-width: 190px;

    .book-img {
      display: block;
      max-width: 100%;
      margin: 0;
    }

    .book-link {
      display: block;
      text-decoration: none;
      padding: 0.8em;
      margin: 0.5em 0;
      text-align: center;
      //border: #272727 solid 1px;
      border: ${({ theme }) =>
        theme === 'light' ? 'rgb(0,0,0,0.5) solid 1px;' : 'rgba(255, 255, 255, 0.5) solid 1px;'};
      cursor: pointer;
      //color: #272727;
      color: ${({ theme }) => (theme === 'light' ? '#272727' : 'rgba(255, 255, 255, 0.8)')};
      font-family: 'SF Pro Text Regular', sans-serif;
      font-size: 14px;
      transition: background 0.2s, color 0.2s;

      &:hover {
        background: #272727;
        color: white;
      }
    }

    p.promotion {
      padding: 0 0 0 0.7em;
      text-indent: -0.7em;
      text-align: left;
      font-family: 'SF Pro Text Regular', sans-serif;
      font-size: 12px;
      letter-spacing: -0.065mm;
      color: #777;
    }
  }

  .book-text {
    font-size: 18px;
    line-height: 1.58;
    letter-spacing: -0.003em;
  }

  .book-review {
    margin: 2em 0;
  }

  .more-book-review {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .hidden {
    visibility: hidden;
    height: 0;

    & > * {
      visibility: hidden;
      height: 0;
    }
  }

  .publisher {
    font-family: 'SF Pro Text Light', sans-serif;
    font-size: 13px;
    text-align: center;
    //color: rgba(0,0,0,.84);
    color: ${({ theme }) => (theme === 'light' ? 'rgba(0,0,0,.84)' : 'rgba(255,255,255,.8)')};
    margin-top: 0;
    padding: 0.5em;
    //background: #f5f5f5;
    background: ${({ theme }) => (theme === 'light' ? ' #f5f5f5' : 'rgba(255,255,255,.1)')};
  }

  .critics-journal {
    font-family: 'SF Pro Text Light', sans-serif;
    font-size: 120%;
    margin-left: 0.5em;
  }

  .critics {
    margin-left: 0.5em;

    li.review-item:not(:last-of-type)::after {
      border-bottom: none !important;
    }
  }

  li.review-item {
    padding: 0;

    .reviewer {
      font-family: 'SF Pro Text Light', sans-serif;
      font-size: 120%;
      margin-left: 0.5em;
    }

    .book-event-host {
      & > p {
        margin: 0;
      }
    }

    .publication {
      margin-left: 0.8em;
    }

    .book-event-info {
      margin: 0 0 1em 2em;
      font-family: 'SF Pro Text Light', sans-serif;
    }

    .divider-style {
      color: ${({theme}) =>
              theme === 'light' ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.3)'};
      padding: 0 0.5em;
    }
  }

  li.review-item:not(:last-of-type)::after {
    content: ''; // This is necessary for the pseudo element to work.
    display: block; // This will put the pseudo element on its own line.
    padding-top: 0;
    margin: 1em auto; // Center the border
    width: 50%;
    border-bottom: ${({theme}) =>
            theme === 'light' ? '1px dashed rgba(0,0,0,0.1)' : '1px dashed rgba(255,255,255,0.3)'};
  }
`;

const Book = ({ lang, Cover, bookData, pdfFile }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // passing an empty array as second argument triggers the callback in useEffect only after the initial render thus replicating `componentDidMount` lifecycle behaviour

  const isEn = lang === 'en';
  const {
    pageName,
    seoTitle,
    seoTitleCN,
    title,
    titleCN,
    sampleChapterLink,
    publisher,
    publisherCN,
    bookLink,
    publisherOrderLink,
    promotionTextEn,
    promotionTextZh,
    readLink,
    bookIntroduction,
    bookIntroductionCN,
    awards,
    authorMeetsCritics,
    bookEvents,
    reviews,
  } = bookData;
  const pathname = pageName.toLowerCase().replace(/ /g, '_');
  const { theme } = useContext(ThemeContext);

  const getReviews = reviews && (
    <ul className="more-book-review">
      {reviews.map((review) => (
        <li key={review.reviewer} className="review-item">
          {/*style={isEn ? {} : {fontFamily: `'STKaiti', 'Kaiti', Helvetica, sans-serif`, fontSize: "20px"}}*/}
          <div className="book-text">
            <ReactMarkdown
              className="reviewer"
              key={review.reviewer}
              children={isEn ? review.reviewer : review.reviewerCN}
              linkTarget="_blank"
            ></ReactMarkdown>
            <ReactMarkdown
              className="review-content"
              key={review.review}
              children={isEn ? review.review : review.reviewCN}
              linkTarget="_blank"
            ></ReactMarkdown>
          </div>
        </li>
      ))}
    </ul>
  );

  const getAwards = (awards) =>
    <ul className="more-book-review">
      {awards.map((award) =>
        <li key={award.issuer} className="review-item">
          {/*style={isEn ? {} : {fontFamily: `'STKaiti', 'Kaiti', Helvetica, sans-serif`, fontSize: "20px"}}*/}
          <div className="book-text">
            <ReactMarkdown
              className="reviewer"
              key={award.title}
              children={isEn ? award.issuer : award.issuerCN}
              linkTarget="_blank"
            ></ReactMarkdown>
            <ReactMarkdown
              className={'review-content'}
              key={award.issuer}
              children={isEn ? award.title : award.titleCN}
              linkTarget="_blank"
            ></ReactMarkdown>
          </div>
        </li>
      )}
    </ul>

  const getAuthorMeetsCritics = (criticsObj) =>
    <>
      <ReactMarkdown
        className="critics-journal"
        key={criticsObj.title}
        children={isEn ? criticsObj.title : criticsObj.titleCN}
        linkTarget="_blank"
      ></ReactMarkdown>
      <ol className="critics">
        {criticsObj.critics.map((critic) =>
          <li key={critic.desc} className="review-item">
            <div className="book-text">
              <ReactMarkdown
                className={'review-content'}
                key={critic.desc}
                children={isEn ? critic.desc : critic.descCN}
                linkTarget="_blank"
              ></ReactMarkdown>
            </div>
          </li>
        )}
      </ol>
    </>

  const getBookEvents = (bookEvents) =>
    <ul className="more-book-review">
      {bookEvents.map((bookEvent) =>
        <li key={bookEvent.date} className="review-item">
          <div className="book-text">
            <ReactMarkdown
              className="reviewer book-event-host"
              key={bookEvent.host}
              children={isEn ? bookEvent.host : bookEvent.hostCN}
              linkTarget="_blank"
            ></ReactMarkdown>
            <div className="book-event-info">
              <p className='inline'>
                {isEn ? bookEvent.name : bookEvent.nameCN}
              </p>
              <p className='inline book-event-info-divider divider-style'>|</p>
              <p className='inline'>
                {isEn ? bookEvent.location : bookEvent.locationCN}
                <span className='divider-style'>|</span>
                <span className='inline'>{isEn ? bookEvent.date : bookEvent.dateCN}</span>
              </p>
            </div>
          </div>
        </li>
      )}
    </ul>

  // const getBookRelatedPublications = (publications) =>
  //   <ul className="more-book-review">
  //     {publications.map((publication) =>
  //       <li key={publication.issuer} className="review-item">
  //         {/*style={isEn ? {} : {fontFamily: `'STKaiti', 'Kaiti', Helvetica, sans-serif`, fontSize: "20px"}}*/}
  //         <div className="book-text">
  //           <ReactMarkdown
  //             className="review-content publication"
  //             key={publication.title}
  //             children={isEn ? publication.title : publication.titleCN}
  //             linkTarget="_blank"
  //           ></ReactMarkdown>
  //         </div>
  //       </li>
  //     )}
  //   </ul>

  // const getBookTitile = (title, sampleChapterLink) => {
  //   if (sampleChapterLink) {
  //     return (
  //
  //       <a
  //         className="book-link"
  //         href={}
  //         /a>
  // }

  return (
    <MainContentContainer theme={theme}>
      <BookContainer theme={theme}>
        <Seo
          title={isEn ? seoTitle : seoTitleCN}
          description={isEn ? bookIntroduction.join(' ') : bookIntroductionCN.join(' ')}
          location={isEn ? '/' + pathname : '/cn/' + pathname}
          lang={lang}
        />
        <div className="grid">
          <h2 className="book-title">{isEn ? title : titleCN}</h2>
          <div className="book-pic-container">
            <div className="gap">
              <div className="book-img">
                <Cover lang={lang}/>
              </div>
              <p className="publisher">{isEn ? publisher : publisherCN}</p>
              {sampleChapterLink &&
                <a style={{fontSize: 13, fontFamily: 'Roboto', fontWeight: 'bold'}}
                   href={`${sampleChapterLink}`}
                   target='_blank'
                   rel="noopener noreferrer"
                >
                  {isEn ? 'Read Sample Chapter' : '试读章节'}
                </a>
              }
              {awards && (
                <AnchorLink href="#awards" className={'book-link'}>
                  {isEn ? 'Award' : '图书奖'}
                </AnchorLink>
              )}
              {pdfFile && (
                <AnchorLink href="#pdfCanvas" className={'book-link'}>
                  {isEn ? 'Table of Contents' : '目录'}
                </AnchorLink>
              )}

              {bookLink && (
                <a className="book-link" target="_blank" href={bookLink} rel="noopener noreferrer">
                  {isEn ? 'Available on Amazon' : '亚马逊有售'}
                </a>
              )}
              {publisherOrderLink && (
                <a className="book-link" target="_blank" href={publisherOrderLink} rel="noopener noreferrer">
                  {isEn ? 'Order from ' + publisher : '从' + publisherCN + '购买'}
                  {(promotionTextEn || promotionTextZh) && '*'}
                </a>
              )}
              {readLink && (
                <a className="book-link" href={readLink}>
                  {isEn ? 'Read Online' : '在线阅读'}
                </a>
              )}
              {promotionTextEn && <p className={'promotion'}>* {isEn ? promotionTextEn : promotionTextZh}</p>}
            </div>
          </div>
          <div className="book-introduction">
            {isEn &&
              bookIntroduction &&
              bookIntroduction.map((text, idx) => (
                <ReactMarkdown
                  className="book-text bigger-first-letter"
                  key={`${title} introduction ${idx}`}
                  children={text}
                />
              ))}
            {!isEn &&
              bookIntroductionCN &&
              bookIntroductionCN.map((text, idx) => (
                <ReactMarkdown
                  className="book-text bigger-first-letter"
                  key={`${title} introduction ${idx}`}
                  children={text}
                />
              ))}
            {
              awards && (
                <div className="book-review section" id='awards'>
                  <h2 className={'section-title'}>{isEn ? 'Award' : '图书奖'}</h2>
                  {getAwards(awards)}
                </div>
              )
            }
            {
              authorMeetsCritics && (
                <div className="book-review section">
                  <h2
                    className={'section-title'}>{isEn ? 'Author-Meets-Critics Special Feature' : '作者与评论家对话专题'}</h2>
                  {getAuthorMeetsCritics(authorMeetsCritics)}
                </div>
              )
            }
            {
              bookEvents && (
                <div className="book-review section">
                  <h2 className={'section-title'}>{isEn ? 'Book Events' : '新书讨论'}</h2>
                  {getBookEvents(bookEvents)}
                </div>
              )
            }
            {reviews && (
              <div className="book-review section">
                <h2 className={'section-title'}>{isEn ? 'Reviews' : '评荐'}</h2>
                {getReviews}
              </div>
            )}

            {pdfFile && (
              <div className="book-review" id="pdfCanvas">
                <h2 className={'section-title'}>{isEn ? 'Table of Contents' : '目录'}</h2>
                <PDFReader pdfFile={pdfFile}/>
              </div>
            )}
          </div>
        </div>
      </BookContainer>
    </MainContentContainer>
  );
};

export default Book;
